import { t } from '@repo/i18n';
import { useLocale } from '@repo/i18n/react';
import type { PolicySnapshot, SubjectProgress } from '@repo/shared/schema';
import { PolicySettings } from '../../../policies';

export const ReportPolicyDetails = ({
  report,
}: {
  report: {
    policySnapshot?: Omit<PolicySnapshot, 'version'>;
    researchCoverage?: {
      subject: { id: string; name: string };
      categories?: SubjectProgress['categories'];
    }[];
  };
}) => {
  useLocale();
  if (!report.policySnapshot) {
    return null;
  }
  return (
    <details className="rounded-lg border bg-card p-4">
      <summary className="cursor-pointer break-all font-medium">
        {t('policies.applied')}:{' '}
        {report.policySnapshot
          ? report.policySnapshot.source === 'RAVEN_DEFAULT'
            ? t('policies.defaults')
            : t('workspace.organization')
          : t('policies.legacy')}
      </summary>
      <div className="mt-4 space-y-5">
        {report.policySnapshot && <PolicySettings policy={report.policySnapshot.policy} />}
        <h3 className="font-medium">{t('policies.coverage')}</h3>
        {report.researchCoverage?.map(({ subject, categories }) => (
          <section className="space-y-2" key={subject.id}>
            <h4 className="font-medium text-sm">{subject.name}</h4>
            <dl className="grid gap-2 sm:grid-cols-2">
              {categories?.map((category) => (
                <div className="rounded border p-2 text-sm" key={category.category}>
                  <dt>{t(`policies.${category.category}`)}</dt>
                  <dd className="text-muted-foreground">{t(`policies.${category.status}`)}</dd>
                </div>
              ))}
            </dl>
          </section>
        ))}
      </div>
    </details>
  );
};
